window.FormErrors = function () {
    this.errors = {};

    this.validated = null;

    this.hasErrors = function () {
        return !window._.isEmpty(this.errors);
    };

    this.has = function (field) {
        if (Array.isArray(field)) {
            let has = false;
            _.forEach(field, item => {
                if (window._.indexOf(window._.keys(this.errors), item) > -1 ) {
                    has = true;
                    return false;
                }
            });
            return has;
        } else {
            return window._.indexOf(window._.keys(this.errors), field) > -1;
        }
    };

    this.all = function () {
        return this.errors;
    };

    this.flatten = function () {
        return window._.flatten(window._.toArray(this.errors));
    };


    this.get = function (field) {
        if (Array.isArray(field)) {
            let error = null;
            _.forEach(field, item => {
                if (this.has(item)) {
                    error = this.errors[item][0];
                    return false;
                }
            });
            return error;
        } else {
            if (this.has(field)) {
                return this.errors[field][0];
            }
        }
    };

    this.allErrorsField = function (field) {
        if (this.has(field)) {
            return this.errors[field];
        }
    };

    this.set = function (errors) {
        if (typeof errors === 'object') {
            this.errors = errors;
        } else {
            this.errors = {'form': ['Something went wrong. Please try again or contact customer support.']};
        }
    };

    this.forget = function () {
        this.errors = {};
    };

    this.add = function (key, error) {
        Vue.set(this.errors, key, [error]);
    };

    this.state = function (field) {
        if (!this.validated && this.has(field)) {
            return false;
        }
        return null;
    };
};
